<template>
  <div
    class="component-container"
    v-if="options && options.length > 1 && selectedOption"
    @click="showOptions = showOption(showOptions)"
  >
    <div class="component__select" :class="{ open: showOptions }">
      <h2>
        <span v-bind:class="{ 'open-select': showOptions }">
          <span class="category">{{ selectedOption ? getValue(selectedOption.category) : '' }} •</span>
          <span class="name">{{ selectedOption ? selectedOption.name : '' }}</span>
          <RoundButton class="bordered button" image="ic-arrow-drop-down.svg" />
        </span>
      </h2>
      <span class="c-arrow-down" v-if="!showOptions" />
      <span class="c-arrow-up" v-if="showOptions" />
    </div>
    <ul class="component__select-options" v-if="showOptions">
      <li v-for="option in otherOptions" v-bind:key="option.href" class="select--option" @click="selectOption(option)">
        <label class="labelSelect">
          <input type="checkbox" :value="option" />
          <span class="category">{{ getValue(option.category) }} •</span>
          <span class="name">{{ option.name }}</span>
        </label>
      </li>
    </ul>
  </div>
  <div class="demo-title" v-else>
    <h2>
      <span class="category">{{ selectedOption ? getValue(selectedOption.category) : '' }} •</span>
      <span class="name">{{ demo.name }}</span>
    </h2>
  </div>
</template>

<script>
import RoundButton from '@Components/Menus/RoundButton.vue';

export default {
  components: {
    RoundButton,
  },
  props: ['options', 'value'],
  methods: {
    showOption(option) {
      return !option;
    },
    getValue(key) {
      return this.$store.getters.getValueById(key);
    },
    selectOption(option) {
      this.selectedOption.selected = false;
      option.selected = true;
      this.$emit('input', option);
    },
    handleFocus() {
      this.showOptions = true;
    },
  },
  computed: {
    selectedOption() {
      if (!this.options) {
        return null;
      }
      if (this.options.length === 1) {
        return this.options[0];
      }
      return this.options.filter(option => option.selected === true)[0];
    },
    otherOptions() {
      return this.options.filter(option => option.selected !== true);
    },
    demo() {
      return this.$store.getters.getDemoById(this.$route.params.id);
    },
  },
  data: () => ({
    showOptions: false,
  }),
};
</script>

<style scoped>
.select-demo {
  color: #1a1a1a;
  opacity: 0.5;
  position: absolute;
  left: 0;
  right: 0;
  top: -12px;
  text-align: center;
}

.demo-title {
  padding: 4px 20px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  display: flex;
  height: 100%;
  align-items: center;
}

.component__select {
  padding: 4px 20px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  transition: background-color 800ms;
  cursor: pointer;
}

.component__select .button {
  transition: transform 300ms;
}

.component__select.open .button {
  transform: rotateZ(180deg);
}

.no-touchevents .component__select:hover {
  background-color: rgba(255, 255, 255, 1);
  transition: background-color 200ms;
}

.open-select {
  position: relative;
}

.open-select::after {
  position: absolute;
  top: 100%;
  left: 0;
  content: '';
  width: calc(100% - 36px);
  padding-top: 4px;
  display: block;
  text-align: center;
  margin: auto;
  border-bottom: 2px solid #0088ec;
}

.button {
  margin-left: 5px;
}

.c-arrow-down {
  justify-self: end;
}

.category {
  color: dimgrey;
  letter-spacing: 0.5px;
}

.name {
  color: black;
  letter-spacing: 0.5px;
  margin-left: 2px;
}

.component__select-options {
  position: absolute;
  cursor: pointer;
  background-color: white;
  margin: 0;
  padding: 0 19px 10px;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid rgba(0, 136, 236, 0.4);
  border-top: 0;
  /*  border-image-source: linear-gradient(0deg, rgba(94,190,179, 1), rgba(94,190,179, 0));
  border-image-slice: 1;*/
}

.labelSelect {
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}

.no-touchevents .select--option:hover .labelSelect::after {
  position: absolute;
  top: 100%;
  left: 0;
  content: '';
  width: 50%;
  padding-top: 4px;
  display: block;
  text-align: center;
  margin: auto;
  border-bottom: 2px solid #0088ec;
}

.select--option {
  display: flex;
  align-items: center;
  height: 35px;
  width: 100%;
  list-style: none;
}

.select--option:last-child {
  border-bottom: none;
}

.select--option:nth-child(2n) {
  background-color: #ffffff;
}

.select--option input {
  display: none;
}

@media (max-width: 1785px) {
  .category {
    font-size: 25px;
    color: dimgrey;
    letter-spacing: 0.5px;
  }
  .name {
    font-size: 25px;
    color: black;
    letter-spacing: 0.5px;
    margin-left: 2px;
  }
}

@media (max-width: 1419px) {
  .category {
    font-size: 18px;
    color: dimgrey;
    letter-spacing: 0.5px;
  }
  .name {
    font-size: 18px;
    color: black;
    letter-spacing: 0.5px;
    margin-left: 2px;
  }
}

@media (max-width: 1148px) {
  .component-container {
    margin-right: 200px;
  }
  .category {
    font-size: 14px;
    color: dimgrey;
    letter-spacing: 0.5px;
  }
  .name {
    font-size: 14px;
    color: black;
    letter-spacing: 0.5px;
    margin-left: 2px;
  }
}
</style>
